import PropTypes from 'prop-types';
import bankId from './bankId';
import brandId from './brandId';

export default {
  ...PropTypes,
  bankId,
  brandId
};
